import type React from 'react';

const RefreshIcon: React.FC = () => (
  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <title>Refresh icon</title>
    <g
      stroke="#747474"
      strokeWidth="1.8"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M11.069 20.138a8.07 8.07 0 118.069-8.07v2.997" />
      <path d="M21 13.31l-1.867 1.862-1.857-1.862" />
    </g>
  </svg>
);

export default RefreshIcon;
